import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Pagination } from "../../../types/Pagination"
import { RootState } from "../../app/store"

export interface TransporterState {
  pagination: Pagination
  query: string
}

const initialState: TransporterState = {
  pagination: {
    page: 0,
    size: 10,
  },
  query: "",
}

export const transporterSlice = createSlice({
  name: "transporter",
  initialState,
  reducers: {
    setTransporterPagination: (state, action: PayloadAction<Pagination>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      }
    },
    setTransporterQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload
    },
  },
})
export const selectTransporterPagination = (state: RootState) =>
  state.transporter.pagination
export const selectTransporterQuery = (state: RootState) =>
  state.transporter.query
export const { setTransporterPagination, setTransporterQuery } =
  transporterSlice.actions
export default transporterSlice.reducer
